var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser14 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.238,
    height: 12.844,
    viewBox: "0 0 11.238 12.844",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M102.422,3.211A3.211,3.211,0,1,1,99.211,0,3.211,3.211,0,0,1,102.422,3.211Z",
    transform: "translate(-93.592)",
    fill: "#888",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M7.867,288H7.448a4.368,4.368,0,0,1-3.658,0H3.372A3.372,3.372,0,0,0,0,291.371v1.044a1.2,1.2,0,0,0,1.2,1.2h8.83a1.2,1.2,0,0,0,1.2-1.2v-1.044A3.372,3.372,0,0,0,7.868,288Z",
    transform: "translate(0 -280.775)",
    fill: "#0d47a1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser14);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.1-4.d49ecfd9391cae5db4af4a9a34454a2b.svg";